export const menuitems = [
  {
    id: 'ManagementReporting',
    page_id: 1,
    isPackage: true,
    path: '/home/reporting/Intro',
    sidebarName: 'Management Reporting',
    navbarName: 'Management Reporting',
  },
  {
    id: 'Strategy',
    page_id: 2,
    isPackage: true,
    path: '/home/strategy',
    sidebarName: 'Strategy',
    navbarName: 'Strategy',
  },
  {
    id: 'Settings',
    page_id: 3,
    isPackage: false,
    sidebarName: 'Settings',
    navbarName: 'Settings',
    children: [
      {
        id: 'CompanySettings',
        page_id: 31,
        path: '/home/settings/company',
        sidebarName: 'Company',
        navbarName: 'Company',
      },
      {
        id: 'SecuritySettings',
        page_id: 32,
        path: '/home/settings/security',
        sidebarName: 'Security',
        navbarName: 'Security',
      },
      {
        id: 'ManagementReportingData',
        page_id: 33,
        path: '/home/settings/managereport',
        sidebarName: 'Management Reporting Data',
        navbarName: 'Management Reporting Data',
      },
      {
        id: 'BudgetForecastCashflow',
        page_id: 34,
        path: '/home/settings/budgetforecastcashflow',
        sidebarName: 'Budget / Forecast / Cashflow',
        navbarName: 'Budget / Forecast / Cashflow',
      },
      {
        id: 'ManagementReportingConfig',
        page_id: 35,
        path: '/home/settings/managereportconfig',
        sidebarName: 'Management Reporting Config',
        navbarName: 'Management Reporting Config',
      },
    ],
  },
  {
    redirect: true,
    isPackage: false,
    path: '/home',
    to: '/home/dashboard',
    navbarName: 'Redirect',
  },
];

export default menuitems;
